import Swiper, { Navigation, Pagination, EffectFade, Scrollbar } from "swiper";
import gsap from "gsap";

document.addEventListener("DOMContentLoaded", () => {
  const tuningSetsMaterial = document.querySelector(".tuning-sets .tuning-buttons__material .tuning-buttons__input");
  const tuningSetsPosition = document.querySelector(".tuning-sets .tuning-buttons__position .tuning-buttons__input");
  const setsSlides = document.querySelectorAll(".tuning-sets .swiper-slide");
  const setsCaptions = Array.from(document.querySelectorAll(".tuning-sets__sets-caption"));
  const tuningSetsScrollbar = document.querySelector(".tuning-sets__sets .swiper-scrollbar");
  const tuningSetsPagination = document.querySelector(".tuning-sets__sets .pagination");
  const tuningSetsLine = document.querySelector(".tuning-sets__line");
  const tuningSetsPrice = document.querySelector(".sets-slider__price strong");

  const setsSlider = new Swiper(".swiper.sets-slider", {
    modules: [Navigation, Pagination, EffectFade, Scrollbar],
    speed: 400,
    spaceBetween: 100,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".tuning-sets__pagination-list",
      clickable: true,
      bulletClass: "about-block__pagination pagination__item",
      bulletActiveClass: "pagination__item--active",
      type: "progressbar",
    },
    allowTouchMove: false,
    on: {
      init: function () {
        setsCaptions[0].classList.add("shown");
      },
      scrollbarDragMove: function () {
        console.log(1);
        var swiperScrollbar = this.scrollbar;
        var maxTranslate = swiperScrollbar.$el[0].offsetWidth - swiperScrollbar.$dragEl[0].offsetWidth;

        if (swiperScrollbar.dragTranslate < 0) {
          swiperScrollbar.dragTranslate = 0;
        } else if (swiperScrollbar.dragTranslate > maxTranslate) {
          swiperScrollbar.dragTranslate = maxTranslate;
        }
      },
    },
    effect: "fade",
    speed: 500,
    fadeEffect: {
      crossFade: true,
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
      snapOnRelease: true,
      dragSize: "26",
    },
  });

  const changePrice = () => {
    let curSlide = setsSlider.slides[setsSlider.activeIndex];

    if (tuningSetsMaterial && tuningSetsPosition) {
      let material = !tuningSetsMaterial?.checked ? tuningSetsMaterial.dataset.unchecked : tuningSetsMaterial.dataset.checked;
      let position = !tuningSetsPosition?.checked ? tuningSetsPosition.dataset.unchecked : tuningSetsPosition.dataset.checked;

      let price = curSlide.querySelector(`[data-material=${material}] [data-position=${position}]`).dataset.price;

      tuningSetsPrice.textContent = price;
    }
  };

  const toggleSlidesImages = () => {
    const delay = 0;
    const duration = 0.3;
    setsSlides.forEach((slide) => {
      const timeLine = gsap.timeline();

      let material = !tuningSetsMaterial.checked ? tuningSetsMaterial.dataset.unchecked : tuningSetsMaterial.dataset.checked;
      let position = !tuningSetsPosition.checked ? tuningSetsPosition.dataset.unchecked : tuningSetsPosition.dataset.checked;

      let materialContent = slide.querySelector(`.swiper-slide__material-content[data-material="${material}"]`);
      let positionContent = materialContent.querySelector(`.swiper-slide__position-content[data-position='${position}']`);

      let materialContentToHide = slide.querySelectorAll(".swiper-slide__material-content");
      let positionContentToHide = slide.querySelectorAll(".swiper-slide__position-content");

      let price = slide.querySelector(`[data-material=${material}] [data-position=${position}]`).dataset.price;

      tuningSetsPrice.textContent = price;

      if (materialContentToHide && positionContentToHide) {
        timeLine.to(materialContentToHide, { opacity: 0, delay, duration });
        timeLine.to(materialContentToHide, { display: "none", delay, duration: 0 });
        timeLine.to(positionContentToHide, { display: "none", opacity: 0, delay, duration: 0 });
      }

      timeLine.to(positionContent, { display: "block", opacity: 1, delay, duration: 0 });
      timeLine.to(materialContent, { display: "block", opacity: 1, delay, duration: 0.1 });
    });

    changePrice();
  };

  const toggleCaptions = () => {
    if (setsCaptions.length > 0) {
      setsCaptions.forEach((caption) => {
        caption.querySelector(".tuning-sets__sets-title").classList.remove("active");
        caption.querySelector(".tuning-sets__sets-description").classList.remove("active");
        caption.querySelector(".tuning-sets__sets-boundary").classList.remove("active");
      });

      for (let i = 0; i <= setsSlider.activeIndex; i++) {
        setsCaptions[i].querySelector(".tuning-sets__sets-boundary").classList.add("active");
      }

      setsCaptions[setsSlider.activeIndex].querySelector(".tuning-sets__sets-title").classList.add("active");
      setsCaptions[setsSlider.activeIndex].querySelector(".tuning-sets__sets-description").classList.add("active");
    }

    return;
  };

  setsSlider.on("slideChange", function (e) {
    toggleCaptions();
    changePrice();
    tuningSetsPagination.style.width = tuningSetsPagination.scrollWidth + "px";
  });

  const startTuningSets = () => {
    toggleSlidesImages();
    toggleCaptions();
  };
  startTuningSets();

  if (tuningSetsMaterial) {
    tuningSetsMaterial.addEventListener("change", (e) => {
      toggleSlidesImages();
    });
  }

  if (tuningSetsPosition) {
    tuningSetsPosition.addEventListener("change", (e) => {
      toggleSlidesImages();
    });
  }

  // Change captions on mobile
  function handleSlideChange() {
    const descriptionMobile = document.querySelector(".tuning-sets__description-mobile");

    setsSlider.on("slideChange", function () {
      var activeIndex = this.activeIndex;

      descriptionMobile.textContent = setsCaptions[activeIndex].querySelector(".tuning-sets__sets-description").textContent;
    });
  }

  const changeScrollbarWidth = () => {
    if (setsCaptions.length > 0) {
      const firstBoundary = setsCaptions[0].querySelector(".tuning-sets__sets-boundary");
      const lastBoundary = setsCaptions[setsCaptions.length - 1].querySelector(".tuning-sets__sets-boundary");

      const startRect = firstBoundary.getBoundingClientRect();
      const endRect = lastBoundary.getBoundingClientRect();
      let distance = 0;
      distance = endRect.left - startRect.left;
      tuningSetsScrollbar.style.width = distance + 24 + "px";
      tuningSetsPagination.style.width = distance + "px";
      tuningSetsLine.style.width = distance + "px";
    }
  };

  changeScrollbarWidth();

  window.addEventListener("resize", function () {
    handleSlideChange();
    changeScrollbarWidth();
  });

  const scrollbarDrag = document.querySelector(".swiper-scrollbar-drag");

  if (scrollbarDrag) {
    const observer = new MutationObserver((mutations) => {
      const match = scrollbarDrag.style.transform.match(/translate3d\(([-.\d]+)px,.*\)/);

      if (match) {
        const value = match[1] - 10;
        document.documentElement.style.setProperty("--drag-bg-width", `${value}px`);
      }
    });

    observer.observe(scrollbarDrag, { attributes: true });
  }
});
